import React from "react";
import "./card-number.css";

interface Props {
  value: string;
}

function formatCardNumber(raw: string): string {
  return raw
    .replace(/\D/g, "")
    .match(/.{1,4}/g)
    ?.join("  ") ?? raw;
}

function CardNumber({ value }: Props) {
  return (
    <span className="card-number">{formatCardNumber(value)}</span>
  );
}

export default CardNumber;
